import { useState, useId } from 'react';
import { Collapse, Empty, Skeleton } from 'antd';
import { useGetTripSteps } from 'api/trips/use-get-trip-steps';
import { TripStep } from './components/trip-step';
import type { ITripStepsProps } from './types';

export const TripSteps: React.FC<ITripStepsProps> = (props) => {
  const { tripId } = props;
  const stepsPanelId = useId();
  const [isOpen, setIsOpen] = useState(false);
  const { data: tripSteps, isLoading } = useGetTripSteps({ tripId, enabled: isOpen });

  const handleCollapseChange = (key: string | string[]) => {
    setIsOpen(!!key.length);
  };

  const tripStepsLength = tripSteps?.length || 0;

  return (
    <Collapse onChange={handleCollapseChange}>
      <Collapse.Panel key={stepsPanelId} header='Trip Steps'>
        {isLoading && <Skeleton />}
        {!isLoading && tripStepsLength === 0 && <Empty description='No trip steps available' />}
        {!isLoading &&
          tripSteps?.map((step, index) => (
            <TripStep key={step.id} step={step} isLast={index === tripStepsLength - 1} />
          ))}
      </Collapse.Panel>
    </Collapse>
  );
};
